import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

import { HeroSplitDefault } from '../../components/default-sections/Hero';
import { various } from "../../assets/const/Images";

import {
  auth,
  registerWithEmailAndPassword,
} from "../firebase/Firebase";

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  const register = () => {
    if (!name) alert("Please enter name");
    registerWithEmailAndPassword(name, email, password); 
  };
  useEffect(() => {
    if (loading) return;
    if (user) navigate("/dashboard");
  }, [user, loading, navigate]);


  const registerForm = () => {
    return (
      <div className="row g-5">
        <div className="col-md-12">
          <div className="needs-validation" snovalidate="">
            <div className="row g-3">
              <div className="col-sm-12">
                <label htmlFor="firstName" className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Full Name"
                />
                <div className="invalid-feedback">
                  Valid first name is required.
                </div>
              </div>

              <div className="col-12">
                <label htmlFor="username" className="form-label">Email</label>
                <div className="input-group has-validation">
                  <span className="input-group-text">@</span>
                  <input
                    type="text"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="E-mail Address"
                  />
                  <div className="invalid-feedback">
                    Your Email is required.
                  </div>
                </div>
              </div>

              <div className="col-12">
                <label htmlFor="email" className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                />
                <div className="invalid-feedback">
                  Password missing.
                </div>
              </div>



              <hr className="my-4" />
              <button className="w-100 btn btn-primary btn-lg" onClick={register}>
                Register
              </button>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (

    <HeroSplitDefault 
      leftHeader="Register"
      leftContent={registerForm()}
      rightContent={<img src={various.register} alt="" /> } />

    
  );
}
export default Register;